import { useEffect } from 'react'
import { useClaimForm } from '../context/ClaimFormContext'

let gtmInjected = false
let gtmScheduled = false
let cookieFirstInjected = false
let elfsightInjected = false

function injectElfsight() {
  if (elfsightInjected) return
  elfsightInjected = true
  const script = document.createElement('script')
  script.src = 'https://elfsightcdn.com/platform.js'
  script.async = true
  document.body.appendChild(script)
}

export default function ExternalScripts() {
  const { data } = useClaimForm()
  const params = data.appParams

  useEffect(() => {
    if (!params) return

    // Google Tag Manager — load after window.load to free up critical path
    if (params.googleAnalyticsEnabled && params.googleTagId && !gtmScheduled) {
      gtmScheduled = true
      const gtmId = params.googleTagId
      window.dataLayer = window.dataLayer || []

      const injectGtm = () => {
        if (gtmInjected) return
        gtmInjected = true

        const script = document.createElement('script')
        script.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://privacy.passengersfriend.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtmId}');`
        document.head.appendChild(script)

        const noscript = document.createElement('noscript')
        const iframe = document.createElement('iframe')
        iframe.src = `https://privacy.passengersfriend.com/ns.html?id=${gtmId}`
        iframe.height = '0'
        iframe.width = '0'
        iframe.style.display = 'none'
        iframe.style.visibility = 'hidden'
        noscript.appendChild(iframe)
        document.body.insertBefore(noscript, document.body.firstChild)
      }

      if (document.readyState === 'complete') {
        injectGtm()
      } else {
        window.addEventListener('load', injectGtm, { once: true })
      }
    }

    // CookieFirst (production only — skip localhost and test environments)
    if (params.domain && !params.domain.includes('test.') && !params.domain.includes('localhost') && !params.domain.includes('127.0.0.1') && !cookieFirstInjected) {
      cookieFirstInjected = true
      const cfScript = document.createElement('script')
      cfScript.src = 'https://consent.cookiefirst.com/sites/claim.passengersfriend.com-063f51bb-06a6-4dcd-9834-ae2eb233038b/consent.js'
      document.head.appendChild(cfScript)
    }
  }, [params])

  useEffect(() => {
    let fallbackTimer
    const events = ['pointerdown', 'keydown', 'scroll', 'touchstart']
    const removeInteractionListeners = () => {
      events.forEach((event) => window.removeEventListener(event, handleInteraction))
    }
    const handleInteraction = () => {
      removeInteractionListeners()
      if (fallbackTimer !== undefined) window.clearTimeout(fallbackTimer)
      injectElfsight()
    }
    const scheduleFallback = () => {
      fallbackTimer = window.setTimeout(handleInteraction, 10000)
    }

    events.forEach((event) => window.addEventListener(event, handleInteraction, { passive: true, once: true }))
    if (document.readyState === 'complete') {
      scheduleFallback()
    } else {
      window.addEventListener('load', scheduleFallback, { once: true })
    }

    return () => {
      removeInteractionListeners()
      window.removeEventListener('load', scheduleFallback)
      if (fallbackTimer !== undefined) window.clearTimeout(fallbackTimer)
    }
  }, [])

  // Move Elfsight portal into the correct .g-badge container (sidebar on desktop, mobile nav on mobile)
  useEffect(() => {
    const movePortal = () => {
      const portal = document.getElementById('__EAAPS_PORTAL')
      const isMobile = window.innerWidth <= 768
      const target = document.querySelector(
        isMobile ? '.claimform-google-review-container .g-badge' : '.claimform-sidebar .g-badge'
      )
      if (!portal || !target) return
      document.querySelectorAll('.g-badge-loaded').forEach((element) => element.classList.remove('g-badge-loaded'))
      if (portal.parentNode !== target) target.appendChild(portal)
      target.classList.add('g-badge-loaded')
    }

    // Elfsight loads async, so poll until the portal appears
    const interval = setInterval(() => {
      const portal = document.getElementById('__EAAPS_PORTAL')
      if (portal) {
        clearInterval(interval)
        movePortal()
      }
    }, 500)

    // Re-evaluate on window resize so the portal moves between sidebar and mobile nav
    const handleResize = () => {
      movePortal()
    }

    window.addEventListener('resize', handleResize)

    return () => {
      clearInterval(interval)
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return null
}
